
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as projednaniHnCggY_45S6T7jrOF9EIl8Y04HbTHe8yeNqlvr9TRdGWgMeta } from "/app/pages/pov/projednani.vue?macro=true";
import { default as adminXleUefnzvB_45vEKdf2nyz_6TB6nzIKL5WFk_PMcgsI00Meta } from "/app/pages/pov/sber-kapacit/admin.vue?macro=true";
import { default as indexbEmogggM8OKZgJbsRh8m_iX4dhSBbY7zAcJ9eSps5w0Meta } from "/app/pages/pov/sber-kapacit/index.vue?macro=true";
import { default as skolytThfMjwuHLXF43fnlMcIR_45aQ3dfZ6Bb94BwIVLh05igMeta } from "/app/pages/pov/sber-kapacit/skoly.vue?macro=true";
import { default as forbiddenFx7QaFdrRHdTfB_mc8h_45uuik9YcqgSWJywB5_x2zTRQMeta } from "/app/pages/pov/sber-kapacit/forbidden.vue?macro=true";
import { default as plneni_45datswBLDy4rtLv9DiblVjuESl9PoUBenaRerprmSUW1j_45QMeta } from "/app/pages/pov/sber-kapacit/plneni-dat.vue?macro=true";
import { default as sber_45kapacit960VkW_45SKYMp6gnWRLnXFW6OToeQin6V3rYlV9jbgiIMeta } from "/app/pages/pov/sber-kapacit.vue?macro=true";
import { default as povRv5MgtOOQ_454DEz_45tT6lxwLAv5YNHHClPWClX6Wza8RkMeta } from "/app/pages/pov.vue?macro=true";
import { default as atlasfiBPbkaB1Hwby14qvQ10Za2cf7CYERh3SuOiPLhvOwUMeta } from "/app/pages/atlas.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as pov20244_45BXRIosYarhWVEmJMYEtl_45_bZ2KP2GS6hIJC2Dzc20Meta } from "/app/pages/pov2024.vue?macro=true";
import { default as povs6lr8sJzTUuCtn6NPqGuFOEJiLQANMYgJ_7F9lM87M4Meta } from "/app/pages/cisla/pov.vue?macro=true";
import { default as _20071aZk1rNr335UjVy3OkhJ6cQKV5zcW0MVwom1KwqKWOgMeta } from "/app/pages/ke-stazeni/2007.vue?macro=true";
import { default as _2008td2lUTVAKNZFulR3ZKDYf13zHmVeuRJ5WdZYQDtt7_45sMeta } from "/app/pages/ke-stazeni/2008.vue?macro=true";
import { default as _2020I7gvlllD_f1sX51Yqr5deBUICqrNZISms_45G1W1bvwo8Meta } from "/app/pages/ke-stazeni/2020.vue?macro=true";
import { default as _2024KJRdQybNZ3cmZhDiXACcgb_45F9NHOumztv_bQELZ6FrkMeta } from "/app/pages/ke-stazeni/2024.vue?macro=true";
import { default as indexZ7F0MoBEzsKh_451xrl2Rf8_45k6xo5_w3L0O8ano_45VXOeEMeta } from "/app/pages/ke-stazeni/2014/index.vue?macro=true";
import { default as _2024_backup6FzzoMVL3WjmUlJ_45yQNB_45YVnbxVmVXvh9HHS6lvbBFwMeta } from "/app/pages/ke-stazeni/2024_backup.vue?macro=true";
import { default as prilohyWJdrcUo_45gzAAFy2QKat4LTINNVASl1FOI_NIN3o_45960Meta } from "/app/pages/ke-stazeni/2010/prilohy.vue?macro=true";
import { default as prilohyVdPsjmArkjucPqU_CgdeCqNIAJJK8zOzmYpeswzjpTkMeta } from "/app/pages/ke-stazeni/2012/prilohy.vue?macro=true";
import { default as prilohyTlv52y123p3_45aXu9_454LSDbkG3ju1p3dDaCWatBGdE98Meta } from "/app/pages/ke-stazeni/2014/prilohy.vue?macro=true";
import { default as prilohy8gOdONl_45u_1XgGGCLZpKBxDOMxo9YxHbFW4_459GHSpGwMeta } from "/app/pages/ke-stazeni/2016/prilohy.vue?macro=true";
import { default as textova_45caste8lguJQZ0CYTL_1LhxL0GMOd2kKTSguMjNzmaiH3E6cMeta } from "/app/pages/ke-stazeni/2010/textova-cast.vue?macro=true";
import { default as textova_45castwyRk_45d2n8Ib50KVkHnogLcTuFszMg6eXCB102N03v74Meta } from "/app/pages/ke-stazeni/2012/textova-cast.vue?macro=true";
import { default as textova_45castkDyyazj_456Eg1bGU5omfVC1HGqD0aLIMyIkPZlgDP_45f4Meta } from "/app/pages/ke-stazeni/2014/textova-cast.vue?macro=true";
import { default as textova_45castsfUwabVez_45XEcr7JuEy60wBJh0VApmv_45S7SPCDpr4hIMeta } from "/app/pages/ke-stazeni/2016/textova-cast.vue?macro=true";
import { default as graficka_45castAOliWAaUlsofOrz2guHg9cRMr0D_45sudkEM3Qmh4Jo1QMeta } from "/app/pages/ke-stazeni/2010/graficka-cast.vue?macro=true";
import { default as graficka_45castgZ242PdIjWBTGmhUp8hE2wvmWXvc2Qn_TGhCeJKiv20Meta } from "/app/pages/ke-stazeni/2012/graficka-cast.vue?macro=true";
import { default as graficka_45castmfMEHY0xG4L52_eFR_45SYcTlAsKk5OPPbaKLBg_45kxEkkMeta } from "/app/pages/ke-stazeni/2014/graficka-cast.vue?macro=true";
import { default as graficka_45cast9ohDmgsl1mqPCM6Sh1v0OvYWNkd8WTdzNNHCzKNV_K0Meta } from "/app/pages/ke-stazeni/2016/graficka-cast.vue?macro=true";
import { default as ke_45stazenisUvqsXQWC48cKvLCm_45cKh_kvP5FY0gy3x8osrorsc6gMeta } from "/app/pages/ke-stazeni.vue?macro=true";
import { default as atlasnxz5_45qKqjBWgQMGvSAZKT63LrtwT_N2F30C7x_egEO0Meta } from "/app/pages/mapy/atlas.vue?macro=true";
import { default as indexlCbZ_45VGBLtXHJnea3eUf9wrpnJ606fJi7Ny6Cpziu3gMeta } from "/app/pages/mapy/index.vue?macro=true";
import { default as projednaniJWyBoQgG1UT9zZbrw_6mL6mVLw9IvqdBAeis8pHbvegMeta } from "/app/pages/projednani.vue?macro=true";
import { default as index4cUG_45sfym_45Ow07MoTPMg_lEIXW9tau63_4561iurmgk4kMeta } from "/app/pages/cisla/index.vue?macro=true";
import { default as sber_45zamerubwwee7VlQ4W87_YKdFIWh_KsgljKTgO1E_45Qr25gofeAMeta } from "/app/pages/sber-zameru.vue?macro=true";
import { default as indexnreh78OvI_xL5DIYk_MdjwtUD3O6_Z007mdZUgLmzSAMeta } from "/app/pages/texty/index.vue?macro=true";
import { default as vyhledavani687SBXo3_UQH_OeI0qZDYO1b0uZUTNHzW3p_45IIg7sGcMeta } from "/app/pages/vyhledavani.vue?macro=true";
import { default as poskytovatelevA2SL9R6fByO072cFm5NcpaKYZO_7nX1aMZlD4HTNfMMeta } from "/app/pages/poskytovatele.vue?macro=true";
import { default as _91filename_93kZM5zurjt8V8Su940yEakH0dUSkGH4ic7iFfrX8XUXAMeta } from "/app/pages/docs/[filename].vue?macro=true";
import { default as index__45kGmZqhY4b7GfcIaW44HrNkBZ0s3_45eKQmXVDSSRDmUMeta } from "/app/pages/o-portalu/index.vue?macro=true";
import { default as _91_46_46_46kody_93hQwLedeqpQgTfyUL3K7ALrno26x9Mxg6Q9nDUX57p4cMeta } from "/app/pages/texty/[...kody].vue?macro=true";
import { default as jevy_45uapibamjn2YUms1_45UdOiIK5niTMH1r7bOEiHgt_45YMQ6hOkMeta } from "/app/pages/o-portalu/jevy-uap.vue?macro=true";
import { default as kontaktyIeCnkJBtUbZuKAxooPOGN4mDSP5nENe1WTNKTGwPQOAMeta } from "/app/pages/o-portalu/kontakty.vue?macro=true";
import { default as praha_4515minKIFtH7snL8qbMgxixVfzeKvOdYJ5HrTwiIV_k0Qy_45kEMeta } from "/app/pages/storymap/praha-15min.vue?macro=true";
import { default as praha_45airbnbxigghgggs9SSo_2uBJrYzr8Iuo9Nk_45Jov_45r_450r5VW1UMeta } from "/app/pages/storymap/praha-airbnb.vue?macro=true";
import { default as atlas_45test_46clientgNCbEygNaQ7O_45KieU4u6s8aOXojG_aJ9b0ts86PueMcMeta } from "/app/pages/mapy/atlas-test.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/app/node_modules/.pnpm/nuxt@3.17.6_@parcel+watcher@2.5.1_@types+node@24.0.10_@vue+compiler-sfc@3.5.17_db0@0.3.2_esli_gzwaqm4nujmso55rnfc2m26nka/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as historicke_45centrum5_mUYo6t_45EINyzq62nfd6J8ObdJIP_45D1Qi6iQuBWPioMeta } from "/app/pages/mapy/historicke-centrum.vue?macro=true";
import { default as praha_45soudrznaSBsmFNIDNRuHabYbdDe_45muCh0tiMNzVlzKzLsUFia7UMeta } from "/app/pages/storymap/praha-soudrzna.vue?macro=true";
import { default as praha_45vybavena6SdPq4yPC0FtO980HqycLIuKpgCCkARwu_45rJfSxqklwMeta } from "/app/pages/storymap/praha-vybavena.vue?macro=true";
import { default as praha_45rozmanita2Nkj3q0e6_LGvD_3VPKbmqqgA5ZjU5Za6wWZ4mQkgi4Meta } from "/app/pages/storymap/praha-rozmanita.vue?macro=true";
import { default as praha_45historickaUgLADb6q_45YCqOxnhBl09TfQgMZjg_45qILVAEE4ttM21MMeta } from "/app/pages/storymap/praha-historicka.vue?macro=true";
import { default as praha_45inkluzivniczRKO4trVXJF6_45xqftTZfzIOp_K2a1GBE8XlX_45w0q08Meta } from "/app/pages/storymap/praha-inkluzivni.vue?macro=true";
import { default as praha_45prumyslovaDVXvvCuYorL74xsepymm0COuW5RKvIx6sRjkdYTs4fAMeta } from "/app/pages/storymap/praha-prumyslova.vue?macro=true";
import { default as praha_45udrzitelnawFGgwkKtJB3yRutgWH9sle0jWqhXKpUhAu1Np07Z43IMeta } from "/app/pages/storymap/praha-udrzitelna.vue?macro=true";
import { default as katalog_45lokalit_46clientLjfrWSbr3YxQMGntIkFbKHSZ0J0g_E72MDYxAZR1zs8Meta } from "/app/pages/mapy/katalog-lokalit.client.vue?macro=true";
import { default as _91skupinaMetrikKod_93_46clientRW8P5bBl_45VAWZFVnNFYtRuTCYSGiRRfrK_45UPkJyTkRAMeta } from "/app/pages/cisla/katalog-indikatoru-a-metrik/[skupinaMetrikKod].client.vue?macro=true";
import { default as katalog_45indikatoru_45a_45metrikq3r64PcJBir8LoT353wKwf6KV661j8dwZtBmViM9CrIMeta } from "/app/pages/cisla/katalog-indikatoru-a-metrik.vue?macro=true";
import { default as indexeppZPR7WjYeyxfUal2YBt4pPj_cZnHGV_zKfwcZWyAcMeta } from "/app/pages/cisla/katalog-mestskych-casti/index.vue?macro=true";
import { default as _91mestskaCastId_93_46clientCqH4iiYCdzUJlB6xjZjfwqlzp4dw95PD2lcErDuV_3sMeta } from "/app/pages/cisla/katalog-mestskych-casti/listy/[mestskaCastId].client.vue?macro=true";
import { default as listydsVxJb5xTe_4ScYFM_45ZxDAdSMGR_456IQkcwK0tYwqoucMeta } from "/app/pages/cisla/katalog-mestskych-casti/listy.vue?macro=true";
import { default as _91metrikaId_93_46clientWj2jXd3oWk3T2PYVzk4aFz23VBc0qZwZ8LaqxAZY8wMMeta } from "/app/pages/cisla/katalog-mestskych-casti/metriky/[metrikaId].client.vue?macro=true";
import { default as metrikyYFDoVLATgaKndi5DU2rZsZaSo8L6AKXYW0MJGk_HLVAMeta } from "/app/pages/cisla/katalog-mestskych-casti/metriky.vue?macro=true";
import { default as o_45uzemne_45analytickych_45podkladechDkof8BHtocKP5XbbCBTlzCmXCVrFhr_45oWJfEHbwM9WcMeta } from "/app/pages/o-portalu/o-uzemne-analytickych-podkladech.vue?macro=true";
import { default as o_45portalu_45a_45souvisejicich_45aplikacichyDVsFnT3WnJnvRfFmGT1C1NcSozaF7ojYo95iAypHFAMeta } from "/app/pages/o-portalu/o-portalu-a-souvisejicich-aplikacich.vue?macro=true";
import { default as component_45stub56vLo4uN_45txTFijViZKlvqhgTyvDy46vFiUWVCsyDzgMeta } from "/app/node_modules/.pnpm/nuxt@3.17.6_@parcel+watcher@2.5.1_@types+node@24.0.10_@vue+compiler-sfc@3.5.17_db0@0.3.2_esli_gzwaqm4nujmso55rnfc2m26nka/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub56vLo4uN_45txTFijViZKlvqhgTyvDy46vFiUWVCsyDzg } from "/app/node_modules/.pnpm/nuxt@3.17.6_@parcel+watcher@2.5.1_@types+node@24.0.10_@vue+compiler-sfc@3.5.17_db0@0.3.2_esli_gzwaqm4nujmso55rnfc2m26nka/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "pov___cs",
    path: "/pov",
    meta: povRv5MgtOOQ_454DEz_45tT6lxwLAv5YNHHClPWClX6Wza8RkMeta || {},
    component: () => import("/app/pages/pov.vue"),
    children: [
  {
    name: "pov-projednani___cs",
    path: "projednani",
    component: () => import("/app/pages/pov/projednani.vue")
  },
  {
    name: sber_45kapacit960VkW_45SKYMp6gnWRLnXFW6OToeQin6V3rYlV9jbgiIMeta?.name,
    path: "sber-kapacit",
    component: () => import("/app/pages/pov/sber-kapacit.vue"),
    children: [
  {
    name: "pov-sber-kapacit-admin___cs",
    path: "admin",
    component: () => import("/app/pages/pov/sber-kapacit/admin.vue")
  },
  {
    name: "pov-sber-kapacit___cs",
    path: "",
    component: () => import("/app/pages/pov/sber-kapacit/index.vue")
  },
  {
    name: "pov-sber-kapacit-skoly___cs",
    path: "skoly",
    component: () => import("/app/pages/pov/sber-kapacit/skoly.vue")
  },
  {
    name: "pov-sber-kapacit-forbidden___cs",
    path: "forbidden",
    component: () => import("/app/pages/pov/sber-kapacit/forbidden.vue")
  },
  {
    name: "pov-sber-kapacit-plneni-dat___cs",
    path: "plneni-dat",
    component: () => import("/app/pages/pov/sber-kapacit/plneni-dat.vue")
  }
]
  }
]
  },
  {
    name: "pov___en",
    path: "/en/pov",
    meta: povRv5MgtOOQ_454DEz_45tT6lxwLAv5YNHHClPWClX6Wza8RkMeta || {},
    component: () => import("/app/pages/pov.vue"),
    children: [
  {
    name: "pov-projednani___en",
    path: "projednani",
    component: () => import("/app/pages/pov/projednani.vue")
  },
  {
    name: sber_45kapacit960VkW_45SKYMp6gnWRLnXFW6OToeQin6V3rYlV9jbgiIMeta?.name,
    path: "sber-kapacit",
    component: () => import("/app/pages/pov/sber-kapacit.vue"),
    children: [
  {
    name: "pov-sber-kapacit-admin___en",
    path: "admin",
    component: () => import("/app/pages/pov/sber-kapacit/admin.vue")
  },
  {
    name: "pov-sber-kapacit___en",
    path: "",
    component: () => import("/app/pages/pov/sber-kapacit/index.vue")
  },
  {
    name: "pov-sber-kapacit-skoly___en",
    path: "skoly",
    component: () => import("/app/pages/pov/sber-kapacit/skoly.vue")
  },
  {
    name: "pov-sber-kapacit-forbidden___en",
    path: "forbidden",
    component: () => import("/app/pages/pov/sber-kapacit/forbidden.vue")
  },
  {
    name: "pov-sber-kapacit-plneni-dat___en",
    path: "plneni-dat",
    component: () => import("/app/pages/pov/sber-kapacit/plneni-dat.vue")
  }
]
  }
]
  },
  {
    name: "atlas___cs",
    path: "/atlas",
    meta: atlasfiBPbkaB1Hwby14qvQ10Za2cf7CYERh3SuOiPLhvOwUMeta || {},
    component: () => import("/app/pages/atlas.vue")
  },
  {
    name: "atlas___en",
    path: "/en/atlas",
    meta: atlasfiBPbkaB1Hwby14qvQ10Za2cf7CYERh3SuOiPLhvOwUMeta || {},
    component: () => import("/app/pages/atlas.vue")
  },
  {
    name: "index___cs",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "pov2024___cs",
    path: "/pov2024",
    meta: pov20244_45BXRIosYarhWVEmJMYEtl_45_bZ2KP2GS6hIJC2Dzc20Meta || {},
    component: () => import("/app/pages/pov2024.vue")
  },
  {
    name: "pov2024___en",
    path: "/en/pov2024",
    meta: pov20244_45BXRIosYarhWVEmJMYEtl_45_bZ2KP2GS6hIJC2Dzc20Meta || {},
    component: () => import("/app/pages/pov2024.vue")
  },
  {
    name: "cisla-pov___cs",
    path: "/cisla/pov",
    component: () => import("/app/pages/cisla/pov.vue")
  },
  {
    name: "cisla-pov___en",
    path: "/en/numbers/pov",
    component: () => import("/app/pages/cisla/pov.vue")
  },
  {
    name: "ke-stazeni___cs",
    path: "/ke-stazeni",
    meta: {"middleware":"default-ke-stazeni"},
    component: () => import("/app/pages/ke-stazeni.vue"),
    children: [
  {
    name: "ke-stazeni-2007___cs",
    path: "2007",
    meta: _20071aZk1rNr335UjVy3OkhJ6cQKV5zcW0MVwom1KwqKWOgMeta || {},
    component: () => import("/app/pages/ke-stazeni/2007.vue")
  },
  {
    name: "ke-stazeni-2008___cs",
    path: "2008",
    meta: _2008td2lUTVAKNZFulR3ZKDYf13zHmVeuRJ5WdZYQDtt7_45sMeta || {},
    component: () => import("/app/pages/ke-stazeni/2008.vue")
  },
  {
    name: "ke-stazeni-2020___cs",
    path: "2020",
    component: () => import("/app/pages/ke-stazeni/2020.vue")
  },
  {
    name: "ke-stazeni-2024___cs",
    path: "2024",
    component: () => import("/app/pages/ke-stazeni/2024.vue")
  },
  {
    name: "ke-stazeni-2014___cs",
    path: "2014",
    meta: indexZ7F0MoBEzsKh_451xrl2Rf8_45k6xo5_w3L0O8ano_45VXOeEMeta || {},
    component: () => import("/app/pages/ke-stazeni/2014/index.vue")
  },
  {
    name: "ke-stazeni-2024_backup___cs",
    path: "2024_backup",
    component: () => import("/app/pages/ke-stazeni/2024_backup.vue")
  },
  {
    name: "ke-stazeni-2010-prilohy___cs",
    path: "2010/prilohy",
    meta: prilohyWJdrcUo_45gzAAFy2QKat4LTINNVASl1FOI_NIN3o_45960Meta || {},
    component: () => import("/app/pages/ke-stazeni/2010/prilohy.vue")
  },
  {
    name: "ke-stazeni-2012-prilohy___cs",
    path: "2012/prilohy",
    meta: prilohyVdPsjmArkjucPqU_CgdeCqNIAJJK8zOzmYpeswzjpTkMeta || {},
    component: () => import("/app/pages/ke-stazeni/2012/prilohy.vue")
  },
  {
    name: "ke-stazeni-2014-prilohy___cs",
    path: "2014/prilohy",
    meta: prilohyTlv52y123p3_45aXu9_454LSDbkG3ju1p3dDaCWatBGdE98Meta || {},
    component: () => import("/app/pages/ke-stazeni/2014/prilohy.vue")
  },
  {
    name: "ke-stazeni-2016-prilohy___cs",
    path: "2016/prilohy",
    meta: prilohy8gOdONl_45u_1XgGGCLZpKBxDOMxo9YxHbFW4_459GHSpGwMeta || {},
    component: () => import("/app/pages/ke-stazeni/2016/prilohy.vue")
  },
  {
    name: "ke-stazeni-2010-textova-cast___cs",
    path: "2010/textova-cast",
    meta: textova_45caste8lguJQZ0CYTL_1LhxL0GMOd2kKTSguMjNzmaiH3E6cMeta || {},
    component: () => import("/app/pages/ke-stazeni/2010/textova-cast.vue")
  },
  {
    name: "ke-stazeni-2012-textova-cast___cs",
    path: "2012/textova-cast",
    meta: textova_45castwyRk_45d2n8Ib50KVkHnogLcTuFszMg6eXCB102N03v74Meta || {},
    component: () => import("/app/pages/ke-stazeni/2012/textova-cast.vue")
  },
  {
    name: "ke-stazeni-2014-textova-cast___cs",
    path: "2014/textova-cast",
    meta: textova_45castkDyyazj_456Eg1bGU5omfVC1HGqD0aLIMyIkPZlgDP_45f4Meta || {},
    component: () => import("/app/pages/ke-stazeni/2014/textova-cast.vue")
  },
  {
    name: "ke-stazeni-2016-textova-cast___cs",
    path: "2016/textova-cast",
    meta: textova_45castsfUwabVez_45XEcr7JuEy60wBJh0VApmv_45S7SPCDpr4hIMeta || {},
    component: () => import("/app/pages/ke-stazeni/2016/textova-cast.vue")
  },
  {
    name: "ke-stazeni-2010-graficka-cast___cs",
    path: "2010/graficka-cast",
    meta: graficka_45castAOliWAaUlsofOrz2guHg9cRMr0D_45sudkEM3Qmh4Jo1QMeta || {},
    component: () => import("/app/pages/ke-stazeni/2010/graficka-cast.vue")
  },
  {
    name: "ke-stazeni-2012-graficka-cast___cs",
    path: "2012/graficka-cast",
    meta: graficka_45castgZ242PdIjWBTGmhUp8hE2wvmWXvc2Qn_TGhCeJKiv20Meta || {},
    component: () => import("/app/pages/ke-stazeni/2012/graficka-cast.vue")
  },
  {
    name: "ke-stazeni-2014-graficka-cast___cs",
    path: "2014/graficka-cast",
    meta: graficka_45castmfMEHY0xG4L52_eFR_45SYcTlAsKk5OPPbaKLBg_45kxEkkMeta || {},
    component: () => import("/app/pages/ke-stazeni/2014/graficka-cast.vue")
  },
  {
    name: "ke-stazeni-2016-graficka-cast___cs",
    path: "2016/graficka-cast",
    meta: graficka_45cast9ohDmgsl1mqPCM6Sh1v0OvYWNkd8WTdzNNHCzKNV_K0Meta || {},
    component: () => import("/app/pages/ke-stazeni/2016/graficka-cast.vue")
  }
]
  },
  {
    name: "ke-stazeni___en",
    path: "/en/download",
    meta: {"middleware":"default-ke-stazeni"},
    component: () => import("/app/pages/ke-stazeni.vue"),
    children: [
  {
    name: "ke-stazeni-2007___en",
    path: "2007",
    meta: _20071aZk1rNr335UjVy3OkhJ6cQKV5zcW0MVwom1KwqKWOgMeta || {},
    component: () => import("/app/pages/ke-stazeni/2007.vue")
  },
  {
    name: "ke-stazeni-2008___en",
    path: "2008",
    meta: _2008td2lUTVAKNZFulR3ZKDYf13zHmVeuRJ5WdZYQDtt7_45sMeta || {},
    component: () => import("/app/pages/ke-stazeni/2008.vue")
  },
  {
    name: "ke-stazeni-2020___en",
    path: "2020",
    component: () => import("/app/pages/ke-stazeni/2020.vue")
  },
  {
    name: "ke-stazeni-2024___en",
    path: "2024",
    component: () => import("/app/pages/ke-stazeni/2024.vue")
  },
  {
    name: "ke-stazeni-2014___en",
    path: "2014",
    meta: indexZ7F0MoBEzsKh_451xrl2Rf8_45k6xo5_w3L0O8ano_45VXOeEMeta || {},
    component: () => import("/app/pages/ke-stazeni/2014/index.vue")
  },
  {
    name: "ke-stazeni-2024_backup___en",
    path: "2024_backup",
    component: () => import("/app/pages/ke-stazeni/2024_backup.vue")
  },
  {
    name: "ke-stazeni-2010-prilohy___en",
    path: "2010/prilohy",
    meta: prilohyWJdrcUo_45gzAAFy2QKat4LTINNVASl1FOI_NIN3o_45960Meta || {},
    component: () => import("/app/pages/ke-stazeni/2010/prilohy.vue")
  },
  {
    name: "ke-stazeni-2012-prilohy___en",
    path: "2012/prilohy",
    meta: prilohyVdPsjmArkjucPqU_CgdeCqNIAJJK8zOzmYpeswzjpTkMeta || {},
    component: () => import("/app/pages/ke-stazeni/2012/prilohy.vue")
  },
  {
    name: "ke-stazeni-2014-prilohy___en",
    path: "2014/prilohy",
    meta: prilohyTlv52y123p3_45aXu9_454LSDbkG3ju1p3dDaCWatBGdE98Meta || {},
    component: () => import("/app/pages/ke-stazeni/2014/prilohy.vue")
  },
  {
    name: "ke-stazeni-2016-prilohy___en",
    path: "2016/prilohy",
    meta: prilohy8gOdONl_45u_1XgGGCLZpKBxDOMxo9YxHbFW4_459GHSpGwMeta || {},
    component: () => import("/app/pages/ke-stazeni/2016/prilohy.vue")
  },
  {
    name: "ke-stazeni-2010-textova-cast___en",
    path: "2010/textova-cast",
    meta: textova_45caste8lguJQZ0CYTL_1LhxL0GMOd2kKTSguMjNzmaiH3E6cMeta || {},
    component: () => import("/app/pages/ke-stazeni/2010/textova-cast.vue")
  },
  {
    name: "ke-stazeni-2012-textova-cast___en",
    path: "2012/textova-cast",
    meta: textova_45castwyRk_45d2n8Ib50KVkHnogLcTuFszMg6eXCB102N03v74Meta || {},
    component: () => import("/app/pages/ke-stazeni/2012/textova-cast.vue")
  },
  {
    name: "ke-stazeni-2014-textova-cast___en",
    path: "2014/textova-cast",
    meta: textova_45castkDyyazj_456Eg1bGU5omfVC1HGqD0aLIMyIkPZlgDP_45f4Meta || {},
    component: () => import("/app/pages/ke-stazeni/2014/textova-cast.vue")
  },
  {
    name: "ke-stazeni-2016-textova-cast___en",
    path: "2016/textova-cast",
    meta: textova_45castsfUwabVez_45XEcr7JuEy60wBJh0VApmv_45S7SPCDpr4hIMeta || {},
    component: () => import("/app/pages/ke-stazeni/2016/textova-cast.vue")
  },
  {
    name: "ke-stazeni-2010-graficka-cast___en",
    path: "2010/graficka-cast",
    meta: graficka_45castAOliWAaUlsofOrz2guHg9cRMr0D_45sudkEM3Qmh4Jo1QMeta || {},
    component: () => import("/app/pages/ke-stazeni/2010/graficka-cast.vue")
  },
  {
    name: "ke-stazeni-2012-graficka-cast___en",
    path: "2012/graficka-cast",
    meta: graficka_45castgZ242PdIjWBTGmhUp8hE2wvmWXvc2Qn_TGhCeJKiv20Meta || {},
    component: () => import("/app/pages/ke-stazeni/2012/graficka-cast.vue")
  },
  {
    name: "ke-stazeni-2014-graficka-cast___en",
    path: "2014/graficka-cast",
    meta: graficka_45castmfMEHY0xG4L52_eFR_45SYcTlAsKk5OPPbaKLBg_45kxEkkMeta || {},
    component: () => import("/app/pages/ke-stazeni/2014/graficka-cast.vue")
  },
  {
    name: "ke-stazeni-2016-graficka-cast___en",
    path: "2016/graficka-cast",
    meta: graficka_45cast9ohDmgsl1mqPCM6Sh1v0OvYWNkd8WTdzNNHCzKNV_K0Meta || {},
    component: () => import("/app/pages/ke-stazeni/2016/graficka-cast.vue")
  }
]
  },
  {
    name: "mapy-atlas___cs",
    path: "/mapy/atlas",
    component: () => import("/app/pages/mapy/atlas.vue")
  },
  {
    name: "mapy-atlas___en",
    path: "/en/maps/atlas",
    component: () => import("/app/pages/mapy/atlas.vue")
  },
  {
    name: "mapy___cs",
    path: "/mapy",
    component: () => import("/app/pages/mapy/index.vue")
  },
  {
    name: "mapy___en",
    path: "/en/maps",
    component: () => import("/app/pages/mapy/index.vue")
  },
  {
    name: "projednani___cs",
    path: "/projednani",
    meta: projednaniJWyBoQgG1UT9zZbrw_6mL6mVLw9IvqdBAeis8pHbvegMeta || {},
    component: () => import("/app/pages/projednani.vue")
  },
  {
    name: "projednani___en",
    path: "/en/projednani",
    meta: projednaniJWyBoQgG1UT9zZbrw_6mL6mVLw9IvqdBAeis8pHbvegMeta || {},
    component: () => import("/app/pages/projednani.vue")
  },
  {
    name: "cisla___cs",
    path: "/cisla",
    component: () => import("/app/pages/cisla/index.vue")
  },
  {
    name: "cisla___en",
    path: "/en/numbers",
    component: () => import("/app/pages/cisla/index.vue")
  },
  {
    name: "sber-zameru___cs",
    path: "/sber-zameru",
    meta: sber_45zamerubwwee7VlQ4W87_YKdFIWh_KsgljKTgO1E_45Qr25gofeAMeta || {},
    component: () => import("/app/pages/sber-zameru.vue")
  },
  {
    name: "sber-zameru___en",
    path: "/en/sber-zameru",
    meta: sber_45zamerubwwee7VlQ4W87_YKdFIWh_KsgljKTgO1E_45Qr25gofeAMeta || {},
    component: () => import("/app/pages/sber-zameru.vue")
  },
  {
    name: "texty___cs",
    path: "/texty",
    component: () => import("/app/pages/texty/index.vue")
  },
  {
    name: "texty___en",
    path: "/en/texts",
    component: () => import("/app/pages/texty/index.vue")
  },
  {
    name: "vyhledavani___cs",
    path: "/vyhledavani",
    component: () => import("/app/pages/vyhledavani.vue")
  },
  {
    name: "vyhledavani___en",
    path: "/en/search",
    component: () => import("/app/pages/vyhledavani.vue")
  },
  {
    name: "poskytovatele___cs",
    path: "/poskytovatele",
    meta: poskytovatelevA2SL9R6fByO072cFm5NcpaKYZO_7nX1aMZlD4HTNfMMeta || {},
    component: () => import("/app/pages/poskytovatele.vue")
  },
  {
    name: "poskytovatele___en",
    path: "/en/poskytovatele",
    meta: poskytovatelevA2SL9R6fByO072cFm5NcpaKYZO_7nX1aMZlD4HTNfMMeta || {},
    component: () => import("/app/pages/poskytovatele.vue")
  },
  {
    name: "docs-filename___cs",
    path: "/docs/:filename()",
    meta: _91filename_93kZM5zurjt8V8Su940yEakH0dUSkGH4ic7iFfrX8XUXAMeta || {},
    component: () => import("/app/pages/docs/[filename].vue")
  },
  {
    name: "docs-filename___en",
    path: "/en/docs/:filename()",
    meta: _91filename_93kZM5zurjt8V8Su940yEakH0dUSkGH4ic7iFfrX8XUXAMeta || {},
    component: () => import("/app/pages/docs/[filename].vue")
  },
  {
    name: "o-portalu___cs",
    path: "/o-portalu",
    component: () => import("/app/pages/o-portalu/index.vue")
  },
  {
    name: "o-portalu___en",
    path: "/en/about",
    component: () => import("/app/pages/o-portalu/index.vue")
  },
  {
    name: "texty-kody___cs",
    path: "/texty/:kody(.*)*",
    component: () => import("/app/pages/texty/[...kody].vue")
  },
  {
    name: "texty-kody___en",
    path: "/en/texts/:kody(.*)*",
    component: () => import("/app/pages/texty/[...kody].vue")
  },
  {
    name: "o-portalu-jevy-uap___cs",
    path: "/o-portalu/jevy-uap",
    component: () => import("/app/pages/o-portalu/jevy-uap.vue")
  },
  {
    name: "o-portalu-jevy-uap___en",
    path: "/en/about/monitored-phenomena",
    component: () => import("/app/pages/o-portalu/jevy-uap.vue")
  },
  {
    name: "o-portalu-kontakty___cs",
    path: "/o-portalu/kontakty",
    component: () => import("/app/pages/o-portalu/kontakty.vue")
  },
  {
    name: "o-portalu-kontakty___en",
    path: "/en/about/contacts",
    component: () => import("/app/pages/o-portalu/kontakty.vue")
  },
  {
    name: "storymap-praha-15min___cs",
    path: "/storymap/praha-15min",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-15min.vue")
  },
  {
    name: "storymap-praha-15min___en",
    path: "/en/storymap/praha-15min",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-15min.vue")
  },
  {
    name: "storymap-praha-airbnb___cs",
    path: "/storymap/praha-airbnb",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-airbnb.vue")
  },
  {
    name: "storymap-praha-airbnb___en",
    path: "/en/storymap/prague-airbnb",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-airbnb.vue")
  },
  {
    name: "mapy-atlas-test___cs",
    path: "/mapy/atlas-test",
    component: () => createClientPage(() => import("/app/pages/mapy/atlas-test.client.vue"))
  },
  {
    name: "mapy-atlas-test___en",
    path: "/en/mapy/atlas-test",
    component: () => createClientPage(() => import("/app/pages/mapy/atlas-test.client.vue"))
  },
  {
    name: "mapy-historicke-centrum___cs",
    path: "/mapy/historicke-centrum",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/mapy/historicke-centrum.vue")
  },
  {
    name: "mapy-historicke-centrum___en",
    path: "/en/mapy/historicke-centrum",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/mapy/historicke-centrum.vue")
  },
  {
    name: "storymap-praha-soudrzna___cs",
    path: "/storymap/praha-soudrzna",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-soudrzna.vue")
  },
  {
    name: "storymap-praha-soudrzna___en",
    path: "/en/storymap/praha-soudrzna",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-soudrzna.vue")
  },
  {
    name: "storymap-praha-vybavena___cs",
    path: "/storymap/praha-vybavena",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-vybavena.vue")
  },
  {
    name: "storymap-praha-vybavena___en",
    path: "/en/storymap/praha-vybavena",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-vybavena.vue")
  },
  {
    name: "storymap-praha-rozmanita___cs",
    path: "/storymap/praha-rozmanita",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-rozmanita.vue")
  },
  {
    name: "storymap-praha-rozmanita___en",
    path: "/en/storymap/diverse-prague",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-rozmanita.vue")
  },
  {
    name: "storymap-praha-historicka___cs",
    path: "/storymap/praha-historicka",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-historicka.vue")
  },
  {
    name: "storymap-praha-historicka___en",
    path: "/en/storymap/praha-historicka",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-historicka.vue")
  },
  {
    name: "storymap-praha-inkluzivni___cs",
    path: "/storymap/praha-inkluzivni",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-inkluzivni.vue")
  },
  {
    name: "storymap-praha-inkluzivni___en",
    path: "/en/storymap/praha-inkluzivni",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-inkluzivni.vue")
  },
  {
    name: "storymap-praha-prumyslova___cs",
    path: "/storymap/praha-prumyslova",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-prumyslova.vue")
  },
  {
    name: "storymap-praha-prumyslova___en",
    path: "/en/storymap/industrial-prague",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-prumyslova.vue")
  },
  {
    name: "storymap-praha-udrzitelna___cs",
    path: "/storymap/praha-udrzitelna",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-udrzitelna.vue")
  },
  {
    name: "storymap-praha-udrzitelna___en",
    path: "/en/storymap/sustainable-prague",
    meta: {"middleware":"redirect-to-external-app"},
    component: () => import("/app/pages/storymap/praha-udrzitelna.vue")
  },
  {
    name: "mapy-katalog-lokalit___cs",
    path: "/mapy/katalog-lokalit",
    component: () => createClientPage(() => import("/app/pages/mapy/katalog-lokalit.client.vue"))
  },
  {
    name: "mapy-katalog-lokalit___en",
    path: "/en/maps/catalogue-of-localities",
    component: () => createClientPage(() => import("/app/pages/mapy/katalog-lokalit.client.vue"))
  },
  {
    name: "cisla-katalog-indikatoru-a-metrik___cs",
    path: "/cisla/katalog-indikatoru-a-metrik",
    meta: {"middleware":"kim"},
    component: () => import("/app/pages/cisla/katalog-indikatoru-a-metrik.vue"),
    children: [
  {
    name: "cisla-katalog-indikatoru-a-metrik-skupinaMetrikKod___cs",
    path: ":skupinaMetrikKod()",
    meta: _91skupinaMetrikKod_93_46clientRW8P5bBl_45VAWZFVnNFYtRuTCYSGiRRfrK_45UPkJyTkRAMeta || {},
    component: () => createClientPage(() => import("/app/pages/cisla/katalog-indikatoru-a-metrik/[skupinaMetrikKod].client.vue"))
  }
]
  },
  {
    name: "cisla-katalog-indikatoru-a-metrik___en",
    path: "/en/numbers/catalogue-of-indicators-and-metrics",
    meta: {"middleware":"kim"},
    component: () => import("/app/pages/cisla/katalog-indikatoru-a-metrik.vue"),
    children: [
  {
    name: "cisla-katalog-indikatoru-a-metrik-skupinaMetrikKod___en",
    path: ":skupinaMetrikKod()",
    meta: _91skupinaMetrikKod_93_46clientRW8P5bBl_45VAWZFVnNFYtRuTCYSGiRRfrK_45UPkJyTkRAMeta || {},
    component: () => createClientPage(() => import("/app/pages/cisla/katalog-indikatoru-a-metrik/[skupinaMetrikKod].client.vue"))
  }
]
  },
  {
    name: "cisla-katalog-mestskych-casti___cs",
    path: "/cisla/katalog-mestskych-casti",
    component: () => import("/app/pages/cisla/katalog-mestskych-casti/index.vue")
  },
  {
    name: "cisla-katalog-mestskych-casti___en",
    path: "/en/numbers/catalogue-of-municipal-districts",
    component: () => import("/app/pages/cisla/katalog-mestskych-casti/index.vue")
  },
  {
    name: "cisla-katalog-mestskych-casti-listy___cs",
    path: "/cisla/katalog-mestskych-casti/listy",
    component: () => import("/app/pages/cisla/katalog-mestskych-casti/listy.vue"),
    children: [
  {
    name: "cisla-katalog-mestskych-casti-listy-mestskaCastId___cs",
    path: ":mestskaCastId()",
    meta: _91mestskaCastId_93_46clientCqH4iiYCdzUJlB6xjZjfwqlzp4dw95PD2lcErDuV_3sMeta || {},
    component: () => createClientPage(() => import("/app/pages/cisla/katalog-mestskych-casti/listy/[mestskaCastId].client.vue"))
  }
]
  },
  {
    name: "cisla-katalog-mestskych-casti-listy___en",
    path: "/en/numbers/catalogue-of-municipal-districts/sheets",
    component: () => import("/app/pages/cisla/katalog-mestskych-casti/listy.vue"),
    children: [
  {
    name: "cisla-katalog-mestskych-casti-listy-mestskaCastId___en",
    path: ":mestskaCastId()",
    meta: _91mestskaCastId_93_46clientCqH4iiYCdzUJlB6xjZjfwqlzp4dw95PD2lcErDuV_3sMeta || {},
    component: () => createClientPage(() => import("/app/pages/cisla/katalog-mestskych-casti/listy/[mestskaCastId].client.vue"))
  }
]
  },
  {
    name: "cisla-katalog-mestskych-casti-metriky___cs",
    path: "/cisla/katalog-mestskych-casti/metriky",
    component: () => import("/app/pages/cisla/katalog-mestskych-casti/metriky.vue"),
    children: [
  {
    name: "cisla-katalog-mestskych-casti-metriky-metrikaId___cs",
    path: ":metrikaId()",
    meta: _91metrikaId_93_46clientWj2jXd3oWk3T2PYVzk4aFz23VBc0qZwZ8LaqxAZY8wMMeta || {},
    component: () => createClientPage(() => import("/app/pages/cisla/katalog-mestskych-casti/metriky/[metrikaId].client.vue"))
  }
]
  },
  {
    name: "cisla-katalog-mestskych-casti-metriky___en",
    path: "/en/numbers/catalogue-of-municipal-districts/metrics",
    component: () => import("/app/pages/cisla/katalog-mestskych-casti/metriky.vue"),
    children: [
  {
    name: "cisla-katalog-mestskych-casti-metriky-metrikaId___en",
    path: ":metrikaId()",
    meta: _91metrikaId_93_46clientWj2jXd3oWk3T2PYVzk4aFz23VBc0qZwZ8LaqxAZY8wMMeta || {},
    component: () => createClientPage(() => import("/app/pages/cisla/katalog-mestskych-casti/metriky/[metrikaId].client.vue"))
  }
]
  },
  {
    name: "o-portalu-o-uzemne-analytickych-podkladech___cs",
    path: "/o-portalu/o-uzemne-analytickych-podkladech",
    component: () => import("/app/pages/o-portalu/o-uzemne-analytickych-podkladech.vue")
  },
  {
    name: "o-portalu-o-uzemne-analytickych-podkladech___en",
    path: "/en/about/about-planning-analytical-materials",
    component: () => import("/app/pages/o-portalu/o-uzemne-analytickych-podkladech.vue")
  },
  {
    name: "o-portalu-o-portalu-a-souvisejicich-aplikacich___cs",
    path: "/o-portalu/o-portalu-a-souvisejicich-aplikacich",
    component: () => import("/app/pages/o-portalu/o-portalu-a-souvisejicich-aplikacich.vue")
  },
  {
    name: "o-portalu-o-portalu-a-souvisejicich-aplikacich___en",
    path: "/en/about/about-the-portal-and-related-applications",
    component: () => import("/app/pages/o-portalu/o-portalu-a-souvisejicich-aplikacich.vue")
  },
  {
    name: component_45stub56vLo4uN_45txTFijViZKlvqhgTyvDy46vFiUWVCsyDzgMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub56vLo4uN_45txTFijViZKlvqhgTyvDy46vFiUWVCsyDzg
  },
  {
    name: component_45stub56vLo4uN_45txTFijViZKlvqhgTyvDy46vFiUWVCsyDzgMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stub56vLo4uN_45txTFijViZKlvqhgTyvDy46vFiUWVCsyDzg
  }
]